import { useState, useEffect, useCallback } from 'react';
import BannerListaReportPage from '../../components/report/BannerListaReportPage';
import ContainerListaReportPage from '../../components/report/ContainerListaReportPage';
import { BestExecutionReport, ReportCreate } from '../../api/apiTypes';
import { fetchBestExecutionReports, createReport } from '../../api/functionApi';
import { useAxiosInterceptor } from '../../api/wrappers';

const ListaReportPage = () => {
  useAxiosInterceptor();

  const [listaReports, setListaReports] = useState<BestExecutionReport[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const reports = await fetchBestExecutionReports();
      setListaReports(reports);
    } catch (err: any) {
      console.error('Errore nel caricamento dati:', err);
      setError('Si è verificato un errore durante il caricamento dei dati.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const addReport = useCallback(
    async (data: ReportCreate) => {
      try {
        const newReport = await createReport(data);
        if (newReport) {
          setListaReports((prev) => [...prev, newReport]);
        }
      } catch (err: any) {
        console.error('Errore durante la creazione del report:', err);
        // L'errore viene mostrato dentro il wizard, che resta aperto: sul 409
        // riporta alla schermata di readiness invece di far ripartire da capo.
        // Qui si rilancia soltanto.
        throw err;
      }
    },
    []
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="flex flex-col bg-gray-50">
      <BannerListaReportPage />
      <div className="px-8 lg:px-16 py-8">
        {error && (
          <div className="bg-red-100 text-red-700 border border-red-400 p-3 rounded mb-4">
            <strong>Errore:</strong> {error}
          </div>
        )}
        <ContainerListaReportPage
          reports={listaReports}
          addReport={addReport}
        />
      </div>
    </div>
  );
};

export default ListaReportPage;
